/**
 * 合约相关
 */
import api from '@/api'

let linearSwap = {}


linearSwap.synckLines = async function (formData) {
    return api.get(`/linearswap/syncKLine`, formData)
}

linearSwap.syncAllKLine = async function (formData) {
    return api.get(`/linearswap/syncAllKLine`, formData)
}

linearSwap.biList = async function (formData) {
    return api.get(`/bi/list`, formData)
}


linearSwap.kLines = async function (formData) {
    return api.get(`/linearswap/kLines`, formData)
}

linearSwap.signalHistory = async function (formData) {
    return api.get(`/linearswap/signalHistory`, formData)
}

linearSwap.setHistoryFake = async function (id, fake) {
    return api.post(`/linearswap/setHistoryFake`, { id, fake })
}

linearSwap.sellOrder = async function (order_id) {
    return api.post(`/linearswap/sellOrder`, { order_id })
}

linearSwap.buyOrder = async function (id, direction) {
    return api.post(`/linearswap/buyOrder`, { id, direction })
}


linearSwap.getSixKillOrderPrices = async function (data) {
    return api.post(`/linearswap/getSixKillOrderPrices`, data)
}


linearSwap.getPrice = async function (data) {
    return api.post(`/linearswap/getPrice`, data)
}

linearSwap.sendManualSignal = async function (data) {
    return api.post(`/linearswap/sendManualSignal`, data)
}

linearSwap.sendQuickManualSignal = async function (data) {
    return api.post(`/linearswap/sendQuickManualSignal`, data)
}

linearSwap.updateUnitPrice = async function (data) {
    return api.post(`/linearswap/updateUnitPrice`, data)
}

linearSwap.updateTrack = async function (data) {
    return api.post(`/linearswap/updateTrack`, data)
}

linearSwap.orders = async function (formData) {
    return api.get(`/linearswap/orders`, formData)
}

linearSwap.holdOrders = async function (formData) {
    return api.get(`/linearswap/holdOrders`, formData)
}

linearSwap.all = async function (formData) {
    return api.get(`/linearswap/all`, formData)
}

linearSwap.getMarket = async function (id) {
    return api.get(`/linearswap/market/get`, { id })
}

linearSwap.setMarket = async function (data) {
    return api.post(`/linearswap/market/set`, data)
}


linearSwap.fav = async function (market_id, status) {
    return api.post(`/linearswap/fav`, { market_id, status })
}

linearSwap.myFav = async function (formData) {
    return api.get(`/linearswap/fav`, formData)
}

linearSwap.setDealConfig = async function (data) {
    return api.post(`/linearswap/dealconfig/set`, data)
}

linearSwap.getDealConfig = async function (id) {
    return api.get(`/linearswap/dealconfig/get`, { id })
}

linearSwap.delDealConfig = async function (id) {
    return api.post(`/linearswap/dealconfig/del`, { id })
}

linearSwap.setAllDealStatus = async function (status) {
    return api.post(`/linearswap/dealconfig/setAllDealStatus`, { status })
}

linearSwap.setAllDealStatus1 = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealStatus1`, param)
}

linearSwap.setAllDealOrderDirection = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealOrderDirection`, param)
}

linearSwap.setAllDealAmountType = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealAmountType`, param)
}

linearSwap.setAllDealSingleVolume = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealSingleVolume`, param)
}

linearSwap.setAllDealAmountMin = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealAmountMin`, param)
}

linearSwap.setAllDealAmountMax = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealAmountMax`, param)
}

linearSwap.setAllDealProfitConfig = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealProfitConfig`, param)
}

linearSwap.setAllDealBigPeriods = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealBigPeriods`, param)
}

linearSwap.setAllDealSmallPeriods = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealSmallPeriods`, param)
}

linearSwap.setAllDealEnterType = async function (param) {
    return api.post(`/linearswap/dealconfig/setAllDealEnterType`, param)
}


linearSwap.dealConfigs = async function (formData) {
    return api.get(`/linearswap/dealconfig/all`, formData)
}

export default linearSwap
